import { CART_DRAWER_PLACEMENT } from "./cartDrawerRuntime";

export function getSelectorByType(type, value) {
  switch (type) {
    case "tag":
    case "group":
      return value;
    case "class":
      return `.${value}`;
    case "id":
      return `#${value}`;
    case "noSelector":
      return "";
    default:
      return value;
  }
}

const dawnLikeCartDrawerConfig = {
  drawer: { type: "tag", value: "cart-drawer" },
  isEmpty: { type: "class", value: "is-empty" },
  widthReference: { type: "class", value: "drawer__cart-items-wrapper" },
  [CART_DRAWER_PLACEMENT.ABOVE_CART_ITEMS]: {
    selector: { type: "id", value: "CartDrawer-Item-1" },
    insertPosition: "beforebegin",
    tableRow: true,
  },
  [CART_DRAWER_PLACEMENT.BELOW_CART_ITEMS]: {
    selector: { type: "group", value: ".cart-items tbody" },
    insertPosition: "beforeend",
    tableRow: true,
  },
};

const cartDrawerConfigsByThemeId = {
  // Dawn and Shopify free themes that share Dawn's cart drawer table structure.
  887: dawnLikeCartDrawerConfig,
  1356: dawnLikeCartDrawerConfig, // Sense
  1368: dawnLikeCartDrawerConfig, // Craft
  1431: dawnLikeCartDrawerConfig, // Studio
  1567: dawnLikeCartDrawerConfig, // Refresh
  1841: dawnLikeCartDrawerConfig, // Origin
  1864: dawnLikeCartDrawerConfig, // Publisher
  1891: dawnLikeCartDrawerConfig, // Spotlight
};

const cartDrawerConfigsBySchemaName = {
  Dawn: dawnLikeCartDrawerConfig,
  Sense: dawnLikeCartDrawerConfig,
  Craft: dawnLikeCartDrawerConfig,
  Studio: dawnLikeCartDrawerConfig,
  Refresh: dawnLikeCartDrawerConfig,
  Origin: dawnLikeCartDrawerConfig,
  Publisher: dawnLikeCartDrawerConfig,
  Spotlight: dawnLikeCartDrawerConfig,
  "Generated Data Theme": dawnLikeCartDrawerConfig,
};

function getMappedElement(theme, mappings) {
  if (theme && mappings[theme]) {
    return mappings[theme];
  }

  for (const config of Object.values(mappings)) {
    const drawerSelector = getSelectorByType(config.drawer.type, config.drawer.value);
    const drawer = document.querySelector(drawerSelector);
    if (drawer) return config;
  }

  return null;
}

export function themeToCartDrawerElementMapper(theme) {
  return getMappedElement(String(theme || ""), cartDrawerConfigsByThemeId);
}

export function themeSchemaToCartDrawerElementMapper(themeSchemaName) {
  return getMappedElement(String(themeSchemaName || ""), cartDrawerConfigsBySchemaName);
}

function queryInDrawer(drawer, selectorConfig) {
  if (!drawer || !selectorConfig) return null;
  const selector = getSelectorByType(selectorConfig.type, selectorConfig.value);
  if (!selector) return null;
  return drawer.querySelector(selector) || document.querySelector(selector);
}

function resolveConfig() {
  const themeId = window?.Shopify?.theme?.theme_store_id;
  const schemaName = window?.Shopify?.theme?.schema_name;

  return (
    themeToCartDrawerElementMapper(themeId) ||
    themeSchemaToCartDrawerElementMapper(schemaName) ||
    dawnLikeCartDrawerConfig
  );
}

export function getCartDrawerTargets() {
  const config = resolveConfig();
  if (!config) return null;

  const drawer = document.querySelector(
    getSelectorByType(config.drawer.type, config.drawer.value)
  );

  if (!drawer) return null;
  const isEmpty = config.isEmpty
    ? drawer.classList.contains(config.isEmpty.value) ||
      !!queryInDrawer(drawer, config.isEmpty)
    : false;
  if (isEmpty) return null;

  const aboveSlot = config[CART_DRAWER_PLACEMENT.ABOVE_CART_ITEMS];
  const belowSlot = config[CART_DRAWER_PLACEMENT.BELOW_CART_ITEMS];
  const aboveTarget = queryInDrawer(drawer, aboveSlot.selector);
  const belowTarget = queryInDrawer(drawer, belowSlot.selector);

  if (!aboveTarget || !belowTarget) return null;

  return {
    drawer,
    config,
    widthReference:
      queryInDrawer(drawer, config.widthReference) ||
      drawer.querySelector(".drawer__inner") ||
      drawer,
    [CART_DRAWER_PLACEMENT.ABOVE_CART_ITEMS]: {
      target: aboveTarget,
      insertPosition: aboveSlot.insertPosition,
      tableRow: aboveSlot.tableRow,
    },
    [CART_DRAWER_PLACEMENT.BELOW_CART_ITEMS]: {
      target: belowTarget,
      insertPosition: belowSlot.insertPosition,
      tableRow: belowSlot.tableRow,
    },
  };
}
